import m from './module';
import EventProduct from '../model/EventProduct';

const type = 'EventProduct';

class EventProductService {
  constructor($q, APIService, LogService) {
    "ngInject";
    this.$q = $q;
    this.APIService = APIService;
    this.LogService = LogService;
  }

  /**
   * Fetch event products with their data and available issue types.
   *
   * @param {number} eventsId
   * @returns {Promise<{products: EventProduct[], issueTypes: Array}>}
   */
  getForEvent(eventsId, staffingUsersId) {
    const path = `/event/${eventsId}/products`;
    const config = { force: true };
    if (staffingUsersId) {
      config.params = { staffing_users_id: staffingUsersId };
    }
    return this.APIService.get(path, config)
      .then(response => {
        const data = response.data || response;
        const products = (data.products || []).map(p => new EventProduct(p));
        const issueTypes = data.issue_types || [];
        return { products, issueTypes };
      })
      .catch(err => {
        this.LogService.error('Error fetching event products:', err);
        return this.$q.reject(err);
      });
  }

  /**
   * Save event product data and issues.
   *
   * @param {number} eventsId
   * @param {EventProduct[]} eventProducts
   * @returns {Promise}
   */
  save(eventsId, eventProducts) {
    const path = `/event/${eventsId}/products`;
    const payload = { products: {}, issues: {} };

    eventProducts.forEach(product => {
      payload.products[product.productKey] = product.serializeData();
      payload.issues[product.productKey] = product.serializeIssue();
    });

    return this.APIService.post(path, payload)
      .catch(err => {
        this.LogService.error('Error saving event products:', err);
        return this.$q.reject(err);
      });
  }
}

export default EventProductService;

m.service('EventProductService', EventProductService);
